import { render, staticRenderFns } from "./FishAvgCostReport.vue?vue&type=template&id=13124c30&"
import script from "./FishAvgCostReport.vue?vue&type=script&lang=js&"
export * from "./FishAvgCostReport.vue?vue&type=script&lang=js&"
import style0 from "./FishAvgCostReport.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports